import {
    INotificationProperties,
    NOTIFICATION_BUTTONS_CLASSNAME,
    Notification,
    createNotification,
} from '@vfde-brix/ws10/notification';
import {
    createComponentById,
    NO_PATTERN_BUSINESS_LOGIC,
    toggleElementVisibility,
} from '@vfde-brix/ws10/core';
import { getAvcNotificationProps, getAvcNotificationTooltip } from 'Container/AvailabilityCheck/util/result';
import { mountToolTip } from './tooltip';
import { HtmlId, ResultHtmlId } from '../enums/elementId';
import { WS10_BUTTON_LINK_BASE_CLASSNAME } from '@vfde-brix/ws10/button-link';
import { mountButtonLink } from './buttonLink';
import { AvcResult } from '@vfde-sails/avc-core';
import { PreMarketingType } from '../enums/product';
import { FiberSupplierData } from 'Container/AvailabilityCheck/interface';

/**
 * WORKAROUND: As the ButtonLink WS10 component cannot
 * accept an onClick event we have to separately
 * add the onClick event on to the element.
 */
const mountNotificationLmButton = (notificationContainer: Element, isVisible: boolean, openLm: Function) => {
    const [ lmButtonContainer ] = notificationContainer
        .getElementsByClassName(NOTIFICATION_BUTTONS_CLASSNAME);
    const [ lmButtonLink ] = notificationContainer
        .getElementsByClassName(WS10_BUTTON_LINK_BASE_CLASSNAME) as HTMLCollectionOf<HTMLAnchorElement>;

    if (!lmButtonContainer || !lmButtonLink) {
        return;
    }

    isVisible && mountButtonLink(lmButtonLink, openLm);
    toggleElementVisibility(lmButtonContainer, isVisible);
};

export const mountNotification = (id: HtmlId, props?: INotificationProperties) =>
    createComponentById(createNotification, id, props ?? NO_PATTERN_BUSINESS_LOGIC);

export const updateAvcNotification = (
    comp: Notification | null,
    avcResult: AvcResult,
    openLm: Function,
    preMarketingType?: PreMarketingType,
    fiberSupplierData?: FiberSupplierData,
) => {
    if (!comp) {
        return;
    }

    comp.update(getAvcNotificationProps(avcResult, preMarketingType, fiberSupplierData));

    const tooltip = getAvcNotificationTooltip(avcResult);

    tooltip && mountToolTip(ResultHtmlId.TOOLTIP, {
        stdHeadline: tooltip.headline,
        stdTooltipId: ResultHtmlId.TOOLTIP,
        txtContent: tooltip.text,
        business: {},
    });

    const lmButtonIsVisible = !avcResult.availability.fiber && !Boolean(preMarketingType);
    mountNotificationLmButton(comp.getContainerElement(), lmButtonIsVisible, openLm);
};
